import { GqlMutationFactory, GqlQueryFactory } from '@skand/graphql-tools';
import { AttributeStore } from './AttributeStore';

/**
 * A handy class to inject dependency to business modules.
 * Almost all business modules requires {@link AttributeStore}, {@link GqlMutationFactory} and {@link GqlQueryFactory} to work.
 * For convenience we wrap them in this class.
 * @example
 * const businessContext = new BusinessContext({ attributeStore, gqlMutationFactory, gqlQueryFactory });
 * const user = new User({ businessContext, rawData: { id: 1, name: 'John' } }); // a businessContext is required to create entity.
 */
export class BusinessContext {
  // allow any here as we don't care it's actual type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly attributeStore: AttributeStore<any>;
  readonly gqlMutationFactory: GqlMutationFactory;
  readonly gqlQueryFactory: GqlQueryFactory;

  /**
   * Constructor of {@link BusinessContext}.
   * @constructor
   * @example
   * ```ts
   * const queryClient = new QueryClient();
   * const requestClient = new GraphQLClient(...);
   * const gqlOperationFactory = new GqlOperationFactory({
   *   request: requestClient.request.bind(requestClient),
   * });
   *
   * const jotaiStore = createStore();
   * const attributeStore = new JotaiAttributeStore({ jotaiStore });
   * const gqlMutationFactory = new GqlMutationFactory({ gqlOperationFactory, queryClient });
   * const gqlQueryFactory = new GqlQueryFactory({ gqlOperationFactory, queryClient });
   * const businessContext = new BusinessContext({
   *   attributeStore,
   *   gqlQueryFactory,
   *   gqlMutationFactory,
   * });
   * ```
   */
  constructor(args: {
    // allow any here as we don't care it's actual type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributeStore: AttributeStore<any>;
    gqlMutationFactory: GqlMutationFactory;
    gqlQueryFactory: GqlQueryFactory;
  }) {
    this.attributeStore = args.attributeStore;
    this.gqlMutationFactory = args.gqlMutationFactory;
    this.gqlQueryFactory = args.gqlQueryFactory;
  }
}
